import { render, staticRenderFns } from "./index.vue?vue&type=template&id=01af09ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=01af09ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01af09ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01af09ca')) {
      api.createRecord('01af09ca', component.options)
    } else {
      api.reload('01af09ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=01af09ca&scoped=true", function () {
      api.rerender('01af09ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/orderList2/index.vue"
export default component.exports